const currencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 0
});

const formatCurrency = (amount) => {
	if (amount == null || Number.isNaN(amount)) return '';
	return currencyFormatter.format(amount);
};

export default formatCurrency;
